import _ from 'lodash';
import { ElLoading, ElNotification } from 'element-plus';
import CryptoJS from 'crypto-js';
import AppConfig from '@/app.config';

const { SECRET_KEY } = AppConfig;

export function showErrorMessages(error) {
  if (error.response) {
    const { errors, message } = error.response.data;
    if (errors) {
      _.forEach(errors, (msgs) => {
        _.forEach(msgs, (msg) => {
          setTimeout(() => {
            ElNotification({
              title: error.response.data.message,
              type: 'error',
              message: msg,
            });
          }, 0);
        });
      });
    } else if (message) {
      setTimeout(() => {
        ElNotification({
          title: error.response.data.message,
          type: 'error',
        });
      }, 0);
    }
  }
}

export function getLoadingInstance(options = {}) {
  return ElLoading.service(_.merge({
    text: 'Loading...',
    lock: true,
  }, options));
}

export function encrypt(data) {
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.enc.Base64.parse(SECRET_KEY);
  const options = {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  };
  const encrypted = CryptoJS.AES.encrypt(data, key, options).toString();
  let result = {
    iv: CryptoJS.enc.Base64.stringify(iv),
    value: encrypted,
    mac: CryptoJS.HmacSHA256(iv + encrypted, key).toString(),
  };
  result = JSON.stringify(result);
  result = CryptoJS.enc.Utf8.parse(result);
  return CryptoJS.enc.Base64.stringify(result);
}

export function decrypt(data) {
  const encrypted = JSON.parse(atob(data));

  const iv = CryptoJS.enc.Base64.parse(encrypted.iv);
  const { value } = encrypted;

  const key = CryptoJS.enc.Base64.parse(SECRET_KEY);

  const decrypted = CryptoJS.AES.decrypt(value, key, {
    iv,
  }).toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(decrypted);
  } catch (e) {
    return decrypted;
  }
}
